import React, { useContext, useEffect, useState } from "react";
import Profile from "../common/Profile";
import Sidebar from "./Sidebar";
import { MdMenu } from "react-icons/md";
import { setSide } from "../../hook/slice";
import { useSelector, useDispatch } from "react-redux";
import { AppContext } from "../../hook/AppContext";

const SlideCol = () => {
  // let { side } = useSelector((state) => state.dashboard) || { side: true };
  const { side, setSide } = useContext(AppContext);
  // const dispatch = useDispatch();

  const handleChange = () => {
    setSide(false);
  };

  return (
    <div>
      {side ? (
        <div className="relative  z-20 md:relative  border-b-richblack-600 ">
          <div className="fixed p-4 top-0 flex items-center w-full h-[calc(10vh -3.5rem)] py-4 justify-between bg-richblack-800">
            <Profile />
            <button
              onClick={handleChange}
              className="group p-1 bg-richblack-700 rounded-md text-richblack-200 cursor-pointer hover:brightness-95 transition-all duration-200"
            >
              <MdMenu className=" text-xl group-hover:font-semibold group-hover:text-richblack-50 transition-all duration-200" />
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default SlideCol;
